/**
 * 体験談検索の絞り込み設定
 *
 * 「体験談をさがす」と「検索結果」の2画面で同じ選択肢を使うため、ここに一本化しています。
 * 選択肢の文字列は、そのままGASへ送られてスプレッドシートの値と照合されます。
 * Googleフォームの選択肢を変更した場合は、ここも必ず合わせてください。
 *
 * 全角／半角の違い（例: 「いじめ／友人関係」と「いじめ/友人関係」）は
 * GAS側の normalizeForCompare_ が吸収しますが、表記自体はフォームに揃えるのが基本です。
 */
const experienceFilterConfig = {
  selectedColor: '#EF9F94',
  buttonColor: '#EF9F94',
  categories: [
    {
      // index 0 → filters.grade
      title: '初めて不登校になった学年',
      options: ['小学校1年生', '小学校2年生', '小学校3年生', '小学校4年生', '小学校5年生', '小学校6年生', '中学校1年生', '中学校2年生', '中学校3年生']
    },
    {
      // index 1 → filters.trigger（フォーム2-1・複数選択）
      title: '不登校になったきっかけ',
      options: ['いじめ／友人関係', '勉強のつまずき', '発達特性・体調要因', '教師や学校との関係', 'はっきりとした原因が無い', 'その他']
    },
    {
      // index 2 → filters.support（フォーム6-x-1）
      title: '利用したサポートの種類',
      options: ['公的なフリースクール', 'スクールカウンセラー', '学校内の支援教室（校内サポートルーム等）', 'スクールソーシャルワーカー', '心のパートナー', '行政の相談窓口', '行政主催のお話会やイベント', '民間のフリースクール', '民間の学習支援', '民間主催のお話会やイベント', '民間の相談窓口', 'その他']
    }
  ]
};

export default experienceFilterConfig;
